/**
 * HEADER CUSTOM HAGGAR JS
 * Handles Drawer interactions (open, close, submenus)
 * Handles Cart Count updates
 */

document.addEventListener('DOMContentLoaded', () => {
  const sections = document.querySelectorAll('.header-custom-haggar');

  sections.forEach((section) => {
    // Drawer Elements
    const drawerToggleBtn = section.querySelector('.hch-categories-toggle');
    const drawer = section.querySelector('.hch-drawer');
    const drawerOverlay = section.querySelector('.hch-drawer-overlay');
    const drawerCloseBtn = section.querySelector('.hch-drawer-close');

    if (!drawerToggleBtn || !drawer || !drawerOverlay) return;

    // Show Drawer early by removing hidden class to allow transitions
    drawer.classList.remove('hdv-hidden');
    drawerOverlay.classList.remove('hdv-hidden');

    function openDrawer() {
      drawer.classList.add('is-open');
      drawerOverlay.classList.add('is-open');
      document.body.style.overflow = 'hidden'; // Prevent scrolling
      drawerToggleBtn.setAttribute('aria-expanded', 'true');
    }

    function closeDrawer() {
      drawer.classList.remove('is-open');
      drawerOverlay.classList.remove('is-open');
      document.body.style.overflow = '';
      drawerToggleBtn.setAttribute('aria-expanded', 'false');

      // Optionally reset all submenus when closed
      setTimeout(() => {
        section.querySelectorAll('.has-accordion.is-active').forEach(item => {
          item.classList.remove('is-active');
          const content = item.querySelector('.hch-accordion-content');
          if (content) content.style.display = 'none';
        });
      }, 300);
    }

    drawerToggleBtn.addEventListener('click', openDrawer);
    drawerCloseBtn.addEventListener('click', closeDrawer);
    drawerOverlay.addEventListener('click', closeDrawer);

    // Accordion handling
    const accordionToggles = section.querySelectorAll('.hch-accordion-toggle');
    accordionToggles.forEach(toggle => {
      toggle.addEventListener('click', (e) => {
        e.preventDefault();
        const parentItem = toggle.closest('.has-accordion');
        if (parentItem) {
          parentItem.classList.toggle('is-active');
          // Only target the immediate next content block
          const content = Array.from(parentItem.children).find(child => child.classList.contains('hch-accordion-content'));
          if (content) {
            content.style.display = content.style.display === 'none' ? 'block' : 'none';
          }
        }
      });
    });
  });

  // Cart Count Update Handler
  const cartCountEl = document.getElementById('hch-cart-count');
  
  document.addEventListener('cart:count:update', (event) => {
    if (!cartCountEl || !event.detail || typeof event.detail.item_count === 'undefined') return;
    
    const count = event.detail.item_count;
    cartCountEl.textContent = count;
    
    if (count > 0) {
      cartCountEl.style.display = '';
    } else {
      cartCountEl.style.display = 'none';
    }
  });
});
